import { render, staticRenderFns } from "./markerClusterExtension.vue?vue&type=template&id=587b6c02"
import script from "./markerClusterExtension.vue?vue&type=script&lang=js"
export * from "./markerClusterExtension.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports